import React, { useContext } from 'react';

import styled from '@emotion/styled';

// import { useAppSelector } from '../../../../redux/store';
import TranslatingContainer from '../../../TranslatingContainer/TranslatingContainer';
import TranslatingContainerProvider from '../../../TranslatingContainer/TranslatingContainerProvider';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import PlainSuccessModal from '../../PlainSuccessModal';
import DirectorOneKycForm from './DirectorOneKycForm';
import DirectorTwoKycForm from './DirectorTwoKycForm';
import KycInformationWrapper from './KycInformationWrapper';

interface KycInformationModalProps {
  className?: string;
}

const KycInformationModal: React.FC<KycInformationModalProps> = ({
  className,
}) => {
  const modalContext = useContext(ModalContext);
  const successActionFn = () => {
    modalContext?.setShowModal(false);
  };

  return (
    <Container>
      <ModalContainer
        label='KYC Information'
        successComponent={() => (
          <PlainSuccessModal
            successActionFn={successActionFn}
            description='Your KYC information has been submitted and  has been sent to compliance for review'
            btnLabel='Go to Dashboard'
            className={className}
          />
        )}
        showSuccessComponent={modalContext?.showSuccessComponent}
      >
        <TranslatingContainerProvider>
          <KycInformationWrapper>
            <FormContainer>
              <TranslatingContainer>
                <DirectorOneKycForm />
                <DirectorTwoKycForm />
              </TranslatingContainer>
            </FormContainer>
          </KycInformationWrapper>
        </TranslatingContainerProvider>
      </ModalContainer>
    </Container>
  );
};

export default KycInformationModal;

const FormContainer = styled.div`
  display: flex;
  overflow: hidden;

  @media (max-width: 884px) {
    width: 100%;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 63px;
`;
